<template>
  <proa-card class="task-card">
    <span v-if="projectLabels">
      <proa-project-label
        v-for="projectLabel in projectLabels"
        :key="projectLabel.id"
        :title="projectLabel.title"
        :color="projectLabel.color"
        class="mb-2"
      />
    </span>
    <div class="title">{{ taskCard.title }}</div>
    <div class="period">
      <span>{{ $t('models.taskCard.attributes.startAt') }}：</span>
      <span v-if="!taskCard.startAt">{{ $t('models.taskCard.placeHolders.period') }}</span>
      <span v-else>
        {{ taskCard.startAt | moment('YYYY年MM月DD日（ddd）') }}
      </span>
    </div>
    <div class="period">
      <span>{{ $t('models.taskCard.attributes.endAt') }}：</span>
      <span v-if="!taskCard.endAt">{{ $t('models.taskCard.placeHolders.period') }}</span>
      <span v-else :class="{ 'overdue': overdue }">
        {{ taskCard.endAt | moment('YYYY年MM月DD日（ddd）') }}
      </span>
    </div>
    <div class="progress-rate">
      <span>{{ $t('models.taskCard.attributes.progress') }}：</span>
      <span :class="{ 'overdue': overdue }">
        {{ taskCard.progress }}%
      </span>
    </div>
    <div v-if="users.length" class="members">
      <div v-for="user in users" :key="user.id" class="avatar-wrapper">
        <proa-avatar
          :src="user.meta.avatar || require('@/assets/images/avatar_default.png')"
          size="xs"
        />
      </div>
    </div>
    <div class="move-handler" @click.stop="() => {}">
      <img :src="require('@/assets/images/icons/move_handler.png')">
    </div>
  </proa-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TaskCardCard',
  props: {
    taskCard: Object
  },
  computed: {
    overdue: function() {
      return this.taskCard.progress != 100 && moment(this.taskCard.endAt).isSameOrBefore(moment(new Date()))
    },
    projectLabels: function() {
      return this.taskCard.projectLabels
    },
    users: function() {
      return this.taskCard.users
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.task-card {
  padding: 15px;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;

  .title {
    font-weight: 600;
    margin-bottom: 20px;
    padding-right: 6px;
    word-break: break-all;
  }

  .members {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;

    .avatar-wrapper {
      position: relative;
      margin: 0 5px 5px 0;
    }
  }

  .period, .progress-rate {
    font-size: 12px;

    .overdue {
      color: $error-color;
    }
  }

  .move-handler {
    position: absolute;
    top: 0;
    right: 0;
    cursor: move;
    padding: 5px;

    img {
      width: 16px !important;
      height: 16px !important;
    }
  }
}

</style>
